export const useHandleImageSwitcher = () => {
	const setImage = (activeColourImageUrl) => {
		// Fix our image url to match woo
		const correctedImageUrl = activeColourImageUrl.replace(
			"300x300",
			"100x100"
		);

		// Find the index of the slide with the image
		const indexOfSlideWithImage = jQuery(
			`.woocommerce-product-gallery__image[data-thumb='${correctedImageUrl}']`
		).index();

		if (indexOfSlideWithImage < 0) return;

		// Switch to the slide with the image
		jQuery(".woocommerce-product-gallery").flexslider(indexOfSlideWithImage);
	};

	return {
		setImage,
	};
};
